<div class="house-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">
    Please log in first.
  </div>

  <section *ngIf="isAuthenticated">
    <div class="message info" *ngIf="isLoading">{{ status }}</div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="houseList"
      [deletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No houses found.'"
      [menuActions]="houseMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedHouse" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">
        &times;
      </button>
      <h3>House Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">Name</span>
          <span class="value">{{ selectedHouse.houseName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">House No</span>
          <span class="value">{{ selectedHouse.houseNo || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Address</span>
          <span class="value">{{ selectedHouse.houseAddress || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Floors</span>
          <span class="value">{{ floorNames(selectedHouse) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created On</span>
          <span class="value">{{ formatDateTime(selectedHouse.createdOn) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Updated On</span>
          <span class="value">{{ formatDateTime(selectedHouse.updatedOn) }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <app-new-edit-house
    *ngIf="isEditOpen && selectedHouse"
    [mode]="'edit'"
    [initialHouse]="selectedHouse"
    (close)="closeEditHouse()"
    (save)="handleEditSave()"
  ></app-new-edit-house>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteHouse"
    [title]="'house.deleteTitle' | t:'Delete House'"
    [message]="'house.deleteMessage' | t:'Delete this house?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteHouse()"
  ></app-confirm-action-modal>
</div>
